import React from 'react';
import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import LightTooltip from './LightTooltip';
import { setOptionChainAction } from '../../actions/optionChainAction';
import { formatDateFunc } from '../../utils/dateFormatFunc';
import { formatATMIV, formatPCHG } from '../../utils/numberFormatFunc';
import StockTicker from './StockTicker';
import { returnCalendarExtraFunc } from '../../Shared';
import Warnings from './Warnings';

import { tableCellStyle } from './index.style';
import styles from './OptionsBoardStyles';

const LeftSidebar = ({ keyPress, changeExpiration }) => {
  const dispatch = useDispatch();
  const { appReducer, optionChainReducer } = useSelector((state) => state);
  const {
    sidepanelExpirations,
    expiration,
    refreshingData,
    refreshingQuote,
    data,
    calendarData,
  } = appReducer;
  const { leftSideWidth, selectedDate, zoompercent } = optionChainReducer;

  const rowClickHandler = async (row) => {
    localStorage.setItem('StrikeValue', 'all');
    const checkboxes = data.map(() => {
      return { value: false };
    });
    dispatch(
      setOptionChainAction({
        check: checkboxes,
        checkPut: checkboxes,
        watchListModalIndex: [],
      })
    );
    await changeExpiration(row.expiry, selectedDate);
  };

  const cells = [
    { content: 'Exp', style: tableCellStyle },
    { content: 'ATMIV', style: { ...tableCellStyle, width: '15%' } },
    { content: 'Chg', style: { ...tableCellStyle, width: '15%' } },
    { content: 'Volume', style: { ...tableCellStyle, width: '30%' } },
  ];

  return (
    <div
      style={{
        height: '100%',
        width: window.innerWidth < 1800 ? '332px' : '',
        minWidth: window.innerWidth > 1700 ? leftSideWidth : '',
      }}
    >
      <div style={{ ...styles.leftSuperContainer, zoom: zoompercent }}>
        <StockTicker keyPress={keyPress} />
        <div style={styles.expirationTitle}>Select Expiration</div>
        <div
          style={
            window.innerWidth < 1800
              ? styles.leftGreendivSmall
              : styles.leftGreendiv
          }
        >
          <div style={styles.midContainer}>
            <TableContainer style={{ height: '100%' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow style={{ height: '7px' }}>
                    {cells.map((cell, index) => (
                      <TableCell
                        key={index}
                        style={cell.style}
                        className="sticky"
                      >
                        {cell.content}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    // weekendErrors != null ? (
                    //   <TableRow>
                    //     <TableCell colSpan={6} align='center'>
                    //       <p style={{ color: 'white', textAlign: 'center' }}>
                    //         Unable to Fetch Data{' '}
                    //       </p>
                    //     </TableCell>
                    //   </TableRow>
                    // ) :
                    (refreshingData && refreshingQuote) || refreshingQuote ? (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          align="center"
                          style={{ borderBottom: 'none' }}
                        >
                          <CircularProgress
                            style={{
                              marginTop: '50px',
                            }}
                            size={24}
                            color="primary"
                          />
                        </TableCell>
                      </TableRow>
                    ) : (
                      sidepanelExpirations &&
                      sidepanelExpirations.map((row) => (
                        <TableRow
                          key={row.expiry}
                          style={
                            row.expiry === expiration
                              ? {
                                  backgroundColor: '#00008B',
                                  cursor: 'pointer',
                                  height: '10px',
                                }
                              : { cursor: 'pointer', height: '10px' }
                          }
                          onClick={() => rowClickHandler(row)}
                        >
                          {returnCalendarExtraFunc(
                            row,
                            sidepanelExpirations,
                            calendarData
                          )[0] === '' && (
                            <TableCell
                              style={styles.expiryStyle}
                              component="th"
                              scope="row"
                            >
                              {formatDateFunc(row.expiry)}
                            </TableCell>
                          )}
                          {returnCalendarExtraFunc(
                            row,
                            sidepanelExpirations,
                            calendarData
                          )[0] !== '' && (
                            <LightTooltip
                              placement="bottom"
                              title={
                                returnCalendarExtraFunc(
                                  row,
                                  sidepanelExpirations,
                                  calendarData
                                )[1]
                              }
                            >
                              <TableCell
                                style={styles.expiryStyle}
                                component="th"
                                scope="row"
                              >
                                {formatDateFunc(row.expiry) + ' '}
                                {returnCalendarExtraFunc(
                                  row,
                                  sidepanelExpirations,
                                  calendarData
                                )[0] !== '' && (
                                  <span style={{ color: '#ebcf34' }}>
                                    {
                                      returnCalendarExtraFunc(
                                        row,
                                        sidepanelExpirations,
                                        calendarData
                                      )[0]
                                    }
                                  </span>
                                )}
                              </TableCell>
                            </LightTooltip>
                          )}

                          <TableCell
                            style={{
                              padding: '3px',
                              color: 'white',
                              borderBottom: 'none',
                              height: 'auto !important',
                              textAlign: 'center',
                            }}
                          >
                            {formatATMIV(row.ivol)}
                          </TableCell>
                          <TableCell
                            style={
                              row.ivol_chg > 0
                                ? {
                                    padding: '3px',
                                    color: '#00C943',
                                    borderBottom: 'none',
                                    height: 'auto !important',
                                    textAlign: 'center',
                                  }
                                : {
                                    padding: '3px',
                                    borderBottom: 'none',
                                    height: 'auto !important',
                                    textAlign: 'center',
                                    color: 'red',
                                  }
                            }
                          >
                            {formatPCHG(row.ivol_chg) === '0.0'
                              ? '-'
                              : formatPCHG(row.ivol_chg)}
                          </TableCell>
                          <TableCell
                            style={{
                              padding: '3px',
                              borderBottom: 'none',
                              paddingRight: '15px',
                              height: 'auto !important',
                              textAlign: 'right',
                              color: 'white',
                            }}
                          >
                            {(
                              row.atm_c_vol +
                              row.atm_p_vol +
                              row.otm_c_vol +
                              row.otm_p_vol +
                              row.itm_c_vol +
                              row.itm_p_vol
                            ).toLocaleString()}
                          </TableCell>
                        </TableRow>
                      ))
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div style={styles.lowLeftContainer}>
            <div
              style={{
                height: '22px',
                width: '100%',
                position: 'sticky',
                background: '#043055',
                top: '-2px',
                zIndex: 9999,
              }}
            ></div>
            <Warnings />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftSidebar;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/LeftSidebar.jsx